import React from "react";
import { Box, Container } from "@material-ui/core";
import FieldPaymentPercent from "./field-payment-percent";
import { HallWagerData } from "../../../interfaces";
import FieldPaymentBonus from "./field-payment-bonus";
import FieldFortuneWheel from "./field-fortune-wheel";
import { useTranslation } from "react-i18next";
import FieldReferral from "./field-referral";

interface WagersProps {
  form: HallWagerData;
  setForm: (f: HallWagerData) => void;
}

const WagersForm: React.FC<WagersProps> = ({ form, setForm }) => {
  const [t] = useTranslation();
  return <Box display="flex" flexDirection="column" justifyContent="space-between" style={{ width: "100%" }}>
    <Container>
      <FieldPaymentPercent error={false} setValue={pp => setForm({ ...form, first_payment_percent: pp })} value={form.first_payment_percent} formHelperText={t("ru.halls.wager.first_payment_percent")} />
      <FieldPaymentBonus error={false} setValue={pp => setForm({ ...form, first_payment_bonus: pp })} value={form.first_payment_bonus} formHelperText={t("ru.halls.wager.first_payment_bonus")} />
      <FieldPaymentPercent error={false} setValue={pp => setForm({ ...form, second_payment_percent: pp })} value={form.second_payment_percent} formHelperText={t("ru.halls.wager.second_payment_percent")} />
      <FieldPaymentBonus error={false} setValue={pp => setForm({ ...form, second_payment_bonus: pp })} value={form.second_payment_bonus} formHelperText={t("ru.halls.wager.second_payment_bonus")} />
      <FieldPaymentPercent error={false} setValue={pp => setForm({ ...form, third_payment_percent: pp })} value={form.third_payment_percent} formHelperText={t("ru.halls.wager.third_payment_percent")} />
      <FieldPaymentBonus error={false} setValue={pp => setForm({ ...form, third_payment_bonus: pp })} value={form.third_payment_bonus} formHelperText={t("ru.halls.wager.third_payment_bonus")} />
      <FieldReferral setValue={pp => setForm({ ...form, referral: pp })} value={form.referral ?? { percent: 0, wager: 0, period: 0 }} />
      <FieldFortuneWheel error={false} setValue={pp => setForm({ ...form, fortune_wheel: pp })} value={form.fortune_wheel ?? 0} />
    </Container>
  </Box>;
}

export default WagersForm;
